import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useMemo, useState } from 'react';
import { PosMicrosIntegrationMicrosOutlet } from '@mews-commander/data-access';
import { useSafeContext } from '@mews/framework';

export interface PosMicrosConfigurationState {
    microsOutlets: Array<PosMicrosIntegrationMicrosOutlet>;
}

interface PosMicrosConfigurationContextProps {
    posMicrosConfigurationState: PosMicrosConfigurationState;
    setPosMicrosConfigurationState: Dispatch<SetStateAction<PosMicrosConfigurationState>>;
}

const PosMicrosConfigurationContext = createContext<PosMicrosConfigurationContextProps | null>(null);

const initialPosMicrosConfigurationState: PosMicrosConfigurationState = {
    microsOutlets: [],
};

/**
 * The below context provider is used because the react-hook form context of the parent component
 * is not accessible in the nested react-hook form component at the moment
 * */

export const PosMicrosConfigurationContextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
    const [posMicrosConfigurationState, setPosMicrosConfigurationState] = useState(initialPosMicrosConfigurationState);
    const contextValue = useMemo<PosMicrosConfigurationContextProps>(
        () => ({
            posMicrosConfigurationState,
            setPosMicrosConfigurationState,
        }),
        [posMicrosConfigurationState, setPosMicrosConfigurationState]
    );

    return (
        <PosMicrosConfigurationContext.Provider value={contextValue}>{children}</PosMicrosConfigurationContext.Provider>
    );
};

export const usePosMicrosConfigurationContext = () => useSafeContext(PosMicrosConfigurationContext);
